import React from "react";
import {
  AboutClasses,
  HeroClasses,
  SkillsClasses,
  TrialBar,
  TechRequiredClasses,
  PricingClasses,
  FAQ,
} from "../../components";
import { aboutcoding, coding, codinghero } from "../../assets/images";
import { Helmet } from "react-helmet";

const CodingClass = () => {
  return (
    <div>
      <Helmet>
        <title>
          Coding Classes for Kids: Turn Gaming into Learning | Tech Tails
        </title>
        <meta
          name="description"
          content="Transform screen time into skill-building with our fun, interactive coding classes! Kids learn to code through game creation, problem-solving, and hands-on projects."
        />
        <meta
          name="keywords"
          content="coding classes for kids, learn to code, game development for kids, programming courses, STEM education, coding education, interactive tech learning, Tech Tails coding"
        />
      </Helmet>

      <HeroClasses
        title="Coding"
        tagline="Learn Programming Through Real Projects"
        desc="Your child will learn to code by building games, apps, and interactive projects. We teach Python, JavaScript, and other languages through hands-on creation, helping them understand logic, problem-solving, and how software actually works."
        img={codinghero}
      />
      <AboutClasses
        title="What They'll Learn"
        desc="Students start with fundamentals like variables, loops, and functions, then progress to building their own projects. Whether it's creating games in Python, building websites, or developing apps, they'll gain practical coding skills that translate to any programming language."
        image={aboutcoding}
      />
      <SkillsClasses
        title="Level Up Your Child's Skills"
        desc="Boost your kid's skills in a fun and cool way with our coding class!"
      />
      <PricingClasses
        title="Private 1:1 Pricing"
        desc="Our pricing is discounted as we enter the early stages of welcoming new students."
      />
      <FAQ />
      <TechRequiredClasses />
    </div>
  );
};

export default CodingClass;
